import * as React from "react";

const ArrowDownSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <path
      fill="#171718"
      d="m8 12.71 1.42-1.42L16 17.87l6.58-6.58L24 12.71l-8 8z"
    ></path>
  </svg>
);

export default ArrowDownSVG;
